import axios from "axios";
import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class PlayBlockAnnotation extends AbstractAnnotations{

    static get TYPE() {
        return "playBlock"
    }

    constructor(builder) {

        super();
        const {pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;

        if (!this.annotationTypes.includes( PlayBlockAnnotation.TYPE)) {
            this.annotationTypes.push(PlayBlockAnnotation.TYPE);
        }

        this.annotations.isPlayBlockBtn = true;


        for (let [key, value] of Object.entries(builder.meta)) {

            if (key === "icon") {
                super.setAnnotations({"iconSrc": value});
            } else if (key === "id") {
                super.setAnnotations({[key]: value});
            } else if (key === "aimPageBtnId") {
                super.setAnnotations({[key]: value});
            } else if (key === "aimPageIndex") {
                super.setAnnotations({[key]: parseInt(value)});
            } else if (key === "hide") {
                if (value === "1") {
                    super.setAnnotations({[key]: parseInt(value)});
                }
            }

            //attempted to get the range "2 to 6" from , for example, audioFileRange=karaoke/5BU7_52/5BU7_52_s_2-6.mp3
            if (key === "audioFileRange") {

                let audioSrcList = [];
                let components = value.split("/");
                let rangeIndicator = components.pop();
                let filenameData = rangeIndicator.split(".")
                let filenameOnly = filenameData[0];
                let extension = filenameData[1];
                let filenameOnlyWithoutRange = filenameOnly.split("_")
                let rangeOny = filenameOnlyWithoutRange.pop();
                let ranges = rangeOny.split("-");

                //if there is only one target audio file path, there will be no hyphen for specifying ranges.
                if (ranges.length > 1) {
                    let rangeStart = parseInt(ranges[0]);
                    let rangeEnd = parseInt(ranges[1]);

                    for (let i = rangeStart; i <= rangeEnd; i++) {
                        audioSrcList.push(`${components.join("/")}/${filenameOnlyWithoutRange.join("_")}_${i}.${extension}`);
                    }
                } else {
                    audioSrcList.push(value);
                }

                super.setAnnotations({audioSrcList: audioSrcList});
            }
        }

    }

}

export default PlayBlockAnnotation